import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Dialog from '../../atoms/feedback/Dialog'
import { useBranchOfficeCreateDialog } from '../../../hooks/useDialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import FormItem from '../../molecules/inputs/FormItem'
import TextField from '../../atoms/inputs/TextField'
import Button from '../../atoms/inputs/Button'
import useYup from '../../../hooks/useYup'
import useValidationRule from '../../../hooks/useValidationRule'
import { CompanyActions } from '../../../store/company'

type Params = {
  name: string
}

export default function BranchOfficeCreateDialog() {
  const { state, close } = useBranchOfficeCreateDialog()
  const dispatch = useDispatch()
  const yup = useYup()
  const rules = useValidationRule()
  const schema = yup.object().shape({
    name: rules.branchOfficeName.required(),
  })
  const form = useForm<Params>({
    resolver: yupResolver(schema),
  })
  const errors = form.formState?.errors

  const handleCreate = useCallback(
    (params: Params) => {
      dispatch(CompanyActions.createBranchOffice({ name: params.name }))
    },
    [dispatch]
  )

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="支店追加"
      onSubmit={form.handleSubmit(handleCreate)}
      actions={
        <FlexRow>
          <Button type="submit">追加</Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <FormItem label="支店名">
          <TextField register={form.register('name')} error={errors.name?.message} />
        </FormItem>
      </FlexColumn>
    </Dialog>
  )
}
